import axios from 'axios';
import { push } from 'connected-react-router';
import messages from '../i18n/messages';
import { doLookup } from './lookup';
import { lookupManagers } from '../app/api';

export const LOGIN_URL = `/api/me`;
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT = 'LOGOUT';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const WHO_AM_I = 'WHO_AM_I';
export const DONT_KNOW_YOU = 'DONT_KNOW_YOU';

const doLookupManager = () => async (dispatch) => {
  let payload = await lookupManagers();
  dispatch({ type: 'lookup/managers', payload });
};

export const doLogin = ({ username, password }) => async (dispatch) => {
  dispatch({ type: LOGIN });
  try {
    let csrfResponse = await axios.get('/csrf');
    const { token, headerName } = csrfResponse.data;
    let headers = { Authorization: 'Basic ' + btoa(`${username}:${password}`), [headerName]: token };
    let res = await axios.post(LOGIN_URL, null, { headers });
    dispatch({
      type: LOGIN_SUCCESS,
      payload: { ...res?.data, loginUsername: res?.data?.details?.loginUsername || username },
    });
    dispatch({ type: CLEAR_MESSAGE });
    dispatch(doLookup());
    dispatch(doLookupManager());
    dispatch(push('/'));
  } catch (error) {
    dispatch({ type: LOGIN_ERROR, payload: { message: messages.login.error.INVALID_CREDENTIAL } });
  }
};
export const doLogout = () => async (dispatch, getState) => {
  dispatch({ type: LOGOUT });
  try {
    await axios.post(`/logout`);
  } catch (error) {
    //don't care
  } finally {
    const state = getState();
    let location = state?.router?.location?.pathname;
    if (location !== LOGIN_URL) dispatch(push('/login'));
  }
};
export const doUnauthorized = () => async (dispatch, getState) => {
  if (getState()?.router?.location?.pathname !== LOGIN_URL) dispatch(push('/login'));
};
export const doMe = () => async (dispatch) => {
  dispatch({ type: WHO_AM_I });
  try {
    let res = await axios.post(LOGIN_URL, null);
    dispatch({
      type: LOGIN_SUCCESS,
      payload: { ...res?.data, loginUsername: res?.data?.details?.loginUsername },
    });
    dispatch(doLookup());
    dispatch(doLookupManager());
  } catch (error) {
    dispatch({ type: DONT_KNOW_YOU });
    dispatch(doLogout());
  }
};
